import { render, staticRenderFns } from "./LoginViaSms.component.vue?vue&type=template&id=7a4822ba&"
import script from "./LoginViaSms.component.vue?vue&type=script&lang=ts&"
export * from "./LoginViaSms.component.vue?vue&type=script&lang=ts&"
import style0 from "./LoginViaSms.component.vue?vue&type=style&index=0&id=7a4822ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports